import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { ChannelManagerConnectionPayload } from 'app/typings/core/extranet/inventory/form/autoInventoryForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '..';

export function useConnectChannelManager(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ChannelManagerConnectionPayload) =>
      apiMutation(
        'POST',
        {
          path: ENDPOINTS.notifyChannelManagerConnection,
          params: { hotelId: hotelId.toString() },
        },
        payload
      ) as Promise<void>,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.autoInventory, { hotelId }],
        exact: false,
      });
    },
    onError: () => {
      message.error('Failed to notify channel manager connection.');
    },
  });
}
